import { API, Endpoints } from "@brg/api";
import { useEffect, useState } from "react";
export var useGetHomeWork = function (request, lang, t, disabled) {
    var _a = useState([]), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!(request === null || request === void 0 ? void 0 : request.projectId) || !(request === null || request === void 0 ? void 0 : request.themeId) || !(request === null || request === void 0 ? void 0 : request.studentId) || disabled)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetHomeWork')
            .get()
            .addQuery('moduleProjectId', request === null || request === void 0 ? void 0 : request.projectId)
            .addQuery('themeLongreadId', request === null || request === void 0 ? void 0 : request.themeId)
            .addQuery('studentId', request === null || request === void 0 ? void 0 : request.studentId)
            // .addQuery('groupId', request?.groupId)
            .send()
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setIsLoading(false);
            if ((r === null || r === void 0 ? void 0 : r.status) === 400 || (r === null || r === void 0 ? void 0 : r.status) === 403) {
                return;
            }
            setResp(API.toLang(r, lang));
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [request === null || request === void 0 ? void 0 : request.projectId, request === null || request === void 0 ? void 0 : request.themeId, request === null || request === void 0 ? void 0 : request.studentId, lang, t, disabled]);
    return { homeWork: resp, isLoading: isLoading, error: error };
};
//# sourceMappingURL=useGetHomework.js.mapimport { API, Endpoints } from "@brg/api";
import { useEffect, useState } from "react";
export var useGetHomeWork = function (request, lang, t, disabled) {
    var _a = useState([]), resp = _a[0], setResp = _a[1];
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!(request === null || request === void 0 ? void 0 : request.projectId) || !(request === null || request === void 0 ? void 0 : request.themeId) || !(request === null || request === void 0 ? void 0 : request.studentId) || disabled)
            return;
        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/GetHomeWork')
            .get()
            .addQuery('moduleProjectId', request === null || request === void 0 ? void 0 : request.projectId)
            .addQuery('themeLongreadId', request === null || request === void 0 ? void 0 : request.themeId)
            .addQuery('studentId', request === null || request === void 0 ? void 0 : request.studentId)
            // .addQuery('groupId', request?.groupId)
            .send()
            .then(function (r) { return r.json(); })
            .then(function (r) {
            setIsLoading(false);
            if ((r === null || r === void 0 ? void 0 : r.status) === 400 || (r === null || r === void 0 ? void 0 : r.status) === 403) {
                return;
            }
            setResp(API.toLang(r, lang));
        })
            .catch(function (e) {
            setIsLoading(false);
            setError(true);
        });
    }, [request === null || request === void 0 ? void 0 : request.projectId, request === null || request === void 0 ? void 0 : request.themeId, request === null || request === void 0 ? void 0 : request.studentId, lang, t, disabled]);
    return { homeWork: resp, isLoading: isLoading, error: error };
};
//# sourceMappingURL=useGetHomework.js.map